import { useGetRegions } from '@api/admin';
import { DomainCustomerID } from '@state';
import { TRegionAddressItem } from '@types';
import axios from 'axios';
import { useRecoilValue } from 'recoil';

export const useSearchRegion = () => {
	const { callGetRegions } = useGetRegions();
	const customerId = useRecoilValue(DomainCustomerID);

	return async (searchText: string = '', state: string = '') => {
		const params: Record<string, string> = {};
		const headers: Record<string, string> = {};
		if (searchText) params.name = searchText;
		if (state) params.state = state;
		if (customerId) headers['X-Customer-Id'] = customerId;
		const resp = await callGetRegions({ params, headers });
		return (resp?.data?.data || []).map((region: any) => ({ label: region.name, value: region.id }));
	};
};

export const searchPostcodeDetails = async (searchText: string): Promise<TRegionAddressItem[]> => {
	if (searchText?.length <= 2) {
		return [];
	}

	const resp = await axios.get(`/api/carrier-rate-cards/postcode/search?postcode=${encodeURIComponent(searchText)}`).catch(() => null);
	return resp?.data || [];
};

export const searchPostcode = async (searchText: string) => {
	const results = await searchPostcodeDetails(searchText);
	return results.map((postcode) => ({
		value: postcode.id,
		label: `${postcode.suburb} ${postcode.postcode}`,
	}));
};
